import PropTypes from 'prop-types';
import React from 'react';
import {Switch, Route, Link, Redirect} from 'react-router-dom';

import {ONBOARDING_STEP_INFOS} from './OnboardingSteps';
import {CurrentUserContext} from '../Router';
import {StreetTeamPipeline} from './StreetTeamPipeline';
import {StreetTeamMemberPage} from './member-profile/StreetTeamMemberPage';
import {RangerMapPage} from './map/RangerMapPage';
import { AcceptScanPage } from './AcceptScanPage';
import { CurrentTasksPage } from './CurrentTasksPage';
import { DropoffsDashboard } from './admin/DropoffsDashboard';
import { PricingDashboard } from './admin/PricingDashboard';
import { RangerTraining } from './RangerTraining';
import { PricingForMarket } from './admin/PricingForMarket';

const OnboardingRoutes = ({location, history, match}) => (
  <Switch>
    {ONBOARDING_STEP_INFOS.map(({
      component: Component,
      slug
    }, idx) => {
      const previous_step = idx > 0
        ? ONBOARDING_STEP_INFOS[idx - 1]
        : null;
      const next_step = idx + 1 < ONBOARDING_STEP_INFOS.length
        ? ONBOARDING_STEP_INFOS[idx + 1]
        : null;

      return (
        <Route
          key={slug}
          path={`/onboarding/${slug}`}
          render={() => (
            <Component
              location={location}
              onClickPrevious={() => {
                if (previous_step) {
                  history.push(`${match.url}/${previous_step.slug}`);
                }
              }}
              onStepComplete={() => {
                if (next_step) {
                  history.push(`${match.url}/${next_step.slug}`);
                }
              }}
            />
          )}
        />
      )
    })}
  </Switch>
)

class StreetTeamOnboarding extends React.Component {
  render() {
    const {match, history, location} = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col">
          
          <img src={`${process.env.PUBLIC_URL}/skip-logo.png`} alt="" height="60" width="142" className="my-3" />

            <CurrentUserContext.Consumer>
              {({currentUser}) => (
                <div>
                  Signed in with {currentUser
                    ? currentUser.email
                    : <Link to="/login">log in</Link>}
                </div>
              )}
            </CurrentUserContext.Consumer>
          </div>
        </div>

        <div className='my-4'>
          <OnboardingRoutes
            location={location}
            history={history}
            match={match}/>
        </div>
      </div>
    )
  }
}

class StreetTeamApp extends React.Component {
  render() {
    return (
      <Switch>
        <Redirect
          exact={true}
          from='/onboarding'
          to={`/onboarding/${ONBOARDING_STEP_INFOS[0].slug}`}
        />

        <Route path='/onboarding' component={StreetTeamOnboarding}/>
        <Route path='/users/:userId' component={StreetTeamMemberPage}/>

        <Route path='/map' component={RangerMapPage} />
        <Route path='/scan' component={RangerMapPage} />
        <Route path='/accept-scan/:vehicleId' component={AcceptScanPage} />
        <Route path='/current-tasks' component={CurrentTasksPage} />

        <Route path='/admin/pipeline' component={StreetTeamPipeline}/>
        <Route path='/admin/dropoffs' component={DropoffsDashboard} />
        <Route path='/admin/pricing/:market' component={PricingForMarket} />
        <Route path='/admin/pricing' component={PricingDashboard} />
        <Route path='/training' component={RangerTraining} />

        <Redirect exact={true} from='/' to='/onboarding' />
      </Switch>
    )
  }
}

StreetTeamApp.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

export {StreetTeamApp};



// WEBPACK FOOTER //
// ./src/street-team/StreetTeamApp.js